import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownModule, CalendarModule, CheckboxModule, AutoCompleteModule, GrowlModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';

import { DownloadRoutingModule } from './download-routing.module';
import { DownloadListComponent } from './download-list/download-list.component';
import { DownloadRequestThComponent } from './download-request-th/download-request-th.component';
import { DownloadRequestIncComponent } from './download-request-inc/download-request-inc.component';
import { CoreModule } from '../../core/core.module';
import { DownloadService } from './download.service';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    TranslateModule,
  ],
  declarations: [
    DownloadListComponent,
    DownloadRequestThComponent,
    DownloadRequestIncComponent
  ],
  providers: [
    DownloadService
  ]
})
export class DownloadModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download.module.ts